import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslate } from "react-polyglot";
import { Link, Typography, Divider } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../Providers/Auth/AuthProvider.jsx";
import { useBaseData } from "../../../Providers/Data/BaseDataProvider.jsx";
import FlexboxHorizontal from "../../../SharedComponents/FlexboxHorizontal.jsx";
import useCompanyPublicId from "../../../hooks/useCompanyPublicId.js";

const useStyles = makeStyles(() => ({
  root: {
    padding: "20px 0",
  },
  content: {
    color: "#64606B",
    "& .MuiDivider-root": {
      height: 24,
      margin: "0 8px",
    },
    "& .MuiLink-root": {
      cursor: "pointer",
    },
    "& p": {
      color: "#64606B",
      fontWeight: 400,
      fontSize: 14,
    },
  },
}));

/** */
const CompanyFooter = () => {
  const t = useTranslate();
  const history = useHistory();
  const { companyName } = useCompanyPublicId();
  const classes = useStyles();
  const { company2 } = useAuth();
  const { company } = useBaseData();

  const company_ = company || company2;

  if (!company_) {
    return null;
  }

  return (
    <>
      {company_.policySettings && (
        <div className={classes.root}>
          <FlexboxHorizontal alignItems="center" justifyContent="center">
            <div className={classes.content}>
              <FlexboxHorizontal alignItems="center" justifyContent="center">
                {company_.policySettings?.termsAndConditions && (
                  <>
                    <Link onClick={() => history.push(`/${companyName || company_.urn}/terms`)}>
                      <Typography component="p" color="inherit">
                        {t("policySettings.termsAndConditions")}
                      </Typography>
                    </Link>
                  </>
                )}
                {company_.policySettings?.termsAndConditions && company_.policySettings?.refund && (
                  <Divider orientation="vertical" />
                )}
                {company_.policySettings?.refund && (
                  <Link onClick={() => history.push(`/${companyName || company_.urn}/policy`)}>
                    <Typography component="p" color="inherit">
                      {t("policySettings.refund")}
                    </Typography>
                  </Link>
                )}
              </FlexboxHorizontal>

              {company_.policySettings.contactInformation && (
                <Typography color="textPrimary" component="p">
                  {company_.policySettings.contactInformation}
                </Typography>
              )}
            </div>
          </FlexboxHorizontal>
        </div>
      )}
    </>
  );
};

export default CompanyFooter;
